// Snackbar helper global
window.showSnackbar = (msg, {actionText, onAction, timeout = 3200} = {}) => {
    const host = document.getElementById('snack-host') || (() => {
        const h = document.createElement('div'); h.id = 'snack-host'; h.className = 'snackbar-host';
        document.body.appendChild(h); return h;
    })();
    const el = document.createElement('div');
    el.className = 'snackbar';
    el.innerHTML = `<span>${msg}</span>` + (actionText ? ` <button class="snackbar__action">${actionText}</button>` : '');
    host.appendChild(el);
    const btn = el.querySelector('.snackbar__action');
    const close = () => el.remove();
    let t = setTimeout(close, timeout);
    btn?.addEventListener('click', () => { clearTimeout(t); onAction?.(); close(); });
    el.addEventListener('mouseenter', () => clearTimeout(t));
    el.addEventListener('mouseleave', () => t = setTimeout(close, 1200));
    return close;
};

// Démo via [data-snack]
document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-snack]');
    if (btn) showSnackbar(btn.getAttribute('data-snack'));
});
